import { useQuery } from '@apollo/client';
import { dealerClient } from '../constants/dealerEnvironment';
import { GET_DEALER } from '../schemas/DealerByIdSchema';

export interface DealerLocationData {
  name: string;
  kvps: string;
  city: string;
  region: string;
}

interface QueryResult {
  dealerById: DealerLocationData;
}

const useGetDealerDetails = (dealerId: string | null) => {
  const { data, error } = useQuery<QueryResult>(GET_DEALER, {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip: !dealerId,
    variables: {
      dealerId,
    },
    context: {
      headers: { clientid: 'wv2ybzheub' },
    },
    client: dealerClient,
  });

  const dealerInfo = data?.dealerById;
  return { dealerInfo };
};
export default useGetDealerDetails;
